<content *ngIf="!imagen">
    <section *ngIf="!showForm" ngClass="{{dragAreaClass}}">
        <div>{{'disenyo-etiquetas.upload.arrastraImagen' | translate}}</div>
        <a (click)="file.click()">
            {{'disenyo-etiquetas.upload.click' | translate}}
        </a>
        <input type="file"
               #file
               [multiple]="false"
               (change)="onFileChange($event)"
               style="display: none" />
    </section>
    <form *ngIf="showForm" [formGroup]="newEditForm" [ngClass]="{'show-error': showError}">
        <div class="entry-2">
            <label>{{'disenyo-etiquetas.upload.imagen' | translate}}</label>
            <input type="text" formControlName="refArchivo" readonly>
        </div>
    </form>
</content>
<content class="image-area" *ngIf="imagen">
    <img src="{{imagen}}" alt="Imagen Asociada al Diseño de Etiquetas">
</content>
<app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
</app-toast>
<footer class="button-bar-right" *ngIf="!showForm && !this.imagen">
    <button class="primary" (click)="close()">{{'global.cancelar' | translate}}</button>
</footer>
<footer class="button-bar-right" *ngIf="showForm && !this.imagen">
    <button class="secondary" (click)="showForm = !showForm">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{'disenyo-etiquetas.upload.subir' | translate}}</button>
</footer>
<footer class="button-bar-center" *ngIf="imagen">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button class="secondary" (click)="delete()">{{'disenyo-etiquetas.upload.eliminar' | translate}}</button>
    <button (click)="download()">{{'disenyo-etiquetas.upload.descargar' | translate}}</button>
</footer>